module.exports = __webpack_public_path__ + "img/njuskalo-technology.33a2bd23.jpg";